// Copyright (c) 2016 Deere & Companypins

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createDuplicatePinPlate} from '../../shared/repositories';

export const createDuplicatePinPlateReport = () =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const duplicatePinPlateState = getState().reports.duplicatePinPlate;

        const reportCriteria = {
            accounts: duplicatePinPlateState.selectedDealers.map(dealer => dealer.account),
            ...duplicatePinPlateState.criteria
        };

        try {

            const data = await createDuplicatePinPlate(reportCriteria);

            dispatch({
                data,
                type: actions.CREATE_DUPLICATE_PIN_PLATE_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult: data.length < 1,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/duplicate-pin-plate/action-creators/create-report.js